import React from 'react';
import {
  Dropdown, DropdownItem
} from 'shared/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './RostersAssignBar.scss';
import DropdownArrow from 'assets/svgs/dropdownArrow.svg';
import ArrowDownIcon from 'assets/svgs/arrowDownIcon.svg';


const RostersAssignBar = (props) => {
  const { t } = useTranslation();

  return(
    <div className="bulk-actions-container">
      <React.Fragment>
          <div className="selected-number-container">

          {props.listOfSelectedExaminees.length ? (
          <span className={'selected-number'}>
            {props.listOfSelectedExaminees.length > 999 ? '999+' : props.listOfSelectedExaminees.length}
          </span>
        ) : (
          <span className="selected-number zero-number">0</span>
        )}
        <span>{t('common.labels.selectedLabel')}</span>

        <hr className="divider" />
        <Dropdown
          customClass="select-item"
          isDropdownAvailable={props.listOfSelectedExaminees}
          chevron={<DropdownArrow />}
        >
          <DropdownItem
            handleClick={props.listOfSelectedExaminees.length > 0 ? () => props.onDeselectAllExaminees() : props.onSelectAll }
            text={props.listOfSelectedExaminees.length > 0 ?  t('common.labels.deselectAll') :  t('common.labels.selectAll')}
          />
        </Dropdown>
          </div>
          <div class="bulk-actions-button-container">
            <div className='bulk-actions-buttons-container'>
              <button
                disabled={!props.listOfSelectedExaminees.length}
                className={`${props.listOfSelectedExaminees.length && 'active'} bulk-actions-button`}
                onClick={props.onAssignExaminees}>{t('rosters.manageAssignment')}
              </button>
              <Dropdown
                customClass={`select-item red ${props.listOfSelectedExaminees.length > 0 && 'active'}`}
                isDropdownAvailable={props.listOfSelectedExaminees.length > 0}
                chevron={<ArrowDownIcon/>}
              >
                <DropdownItem
                  handleClick={props.openAbsentModal}
                  text={t('roomRoster.markAsAbsent')}
                  key='1'
                />
                <DropdownItem
                  handleClick={props.openDeniedModal}
                  text={t('roomRoster.markAsDenied')}
                  key='2'
                />
              </Dropdown>
            </div>
          </div>
      </React.Fragment>
    </div>
  )
};


RostersAssignBar.propTypes = {
  onDeselectAllExaminees: PropTypes.func,
  onSelectAll: PropTypes.func,
  onAssignExaminees: PropTypes.func.isRequired,
};

export default RostersAssignBar;
